<template>
  <div id="recaptcha_container"
       class="tfb-text-standard-smaller">
    This site is protected by reCAPTCHA.
  </div>
</template>
<script>
  export default {
    name: 'EnterpriseRecaptcha',
    mounted() {
      // window.onloadCallback = () => {
      //  // no-undef
      //  /* eslint no-undef: 0 */
      //  grecaptcha.enterprise.render('recaptcha_container', {
      //    sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
      //    action: 'login',
      //    callback: (token) => {
      //      window.recaptcha_token = token;
      //      console.log('recaptcha token : ', token);
      //    },
      //  });
      // };
      window.onloadCallback = () => {
        /* eslint no-undef: 0 */
        window.grecaptcha.enterprise.ready(async () => {
          const captchaToken = await window.grecaptcha.enterprise.execute(process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY, { action: 'LOGIN' });
          // console.log(captchaToken);
          this.$store.dispatch('app/setReCaptchaToken', captchaToken);
        });
      };

      // const recaptchaScript = document.createElement('script');
      // recaptchaScript.setAttribute(
      //  'src',
      //  'https://www.google.com/recaptcha/enterprise.js?render=6LdNQcUsAAAAACB2JnkAmKYuj83HeimDuX1UQ1TB&onload=onloadCallback',
      // );
      // recaptchaScript.setAttribute('async', 'true');
      // recaptchaScript.setAttribute('defer', 'true');
      // document.head.appendChild(recaptchaScript);
    },
  };
</script>
<style lang="scss">
  .grecaptcha-badge {
    visibility: hidden;
  }
</style>
